"use client";

import {usePathname} from "next/navigation";
import {useEffect, useState} from "react";
import {isSameNextAppPath} from "./urlUtils";

/**
 * Determines whether the current browser path is the same as the given string.
 *
 * Works only in client-side code.
 *
 * @param href - The string to check
 * @returns boolean
 */
export const useIsHrefCurrentPath = (href?: string) => {
	const currentPath = usePathname();
	const [isHrefCurrentPage, setIsHrefCurrentPage] = useState<boolean>(false);

	useEffect(() => {
		if (href) {
			setIsHrefCurrentPage(isSameNextAppPath(currentPath, href));
			return;
		}

		setIsHrefCurrentPage(false);
	}, [currentPath, href]);

	return isHrefCurrentPage;
};
